// Highcharts engine setup for the headless render-shell bundle.
// Mirrors the live stats bundle's init in app/stats/page/export.js — the same
// modules must be active so headless charts render byte-identically (pixel-parity)
// and chart.getSVG() (provided by the exporting module) is available to the
// useExportableChart hook in ChartContainer.jsx.
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/02-highcharts-bars.md §4.1, §7

import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import HighchartsSunburst from 'highcharts/modules/sunburst'
import HighchartsTreemap from 'highcharts/modules/treemap'
import HighchartsTreegraph from 'highcharts/modules/treegraph'
import HighchartsExporting from 'highcharts/modules/exporting'

HighchartsMore(Highcharts)
HighchartsSunburst(Highcharts)
HighchartsTreemap(Highcharts)
HighchartsTreegraph(Highcharts)
HighchartsExporting(Highcharts)
